var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v(" "+_vm._s(new Date().getFullYear())+" © "+_vm._s(_vm.nameApp)+" "+_vm._s(_vm.countryApp === _vm.countryColombia ? 'SAS' : '')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }